import { render, staticRenderFns } from "./newSwiper.vue?vue&type=template&id=5946d74c&scoped=true"
import script from "./newSwiper.vue?vue&type=script&lang=js"
export * from "./newSwiper.vue?vue&type=script&lang=js"
import style0 from "./newSwiper.vue?vue&type=style&index=0&id=5946d74c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946d74c",
  null
  
)

export default component.exports